<div class="relative h-full" [ngClass]="{'primary': style() === 'primary', 'secondary': style() !== 'primary'}">
    <div class="h-full absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
        <img [src]="images.search" class="w-5 h-5 text-gray-500 dark:text-gray-400" />
    </div>
    <input type="text" class="h-full border neutrals-grey-02-border focus:border-transparent focus:ring-0 pl-8 pr-8 rounded text-sm" [ngClass]="{'min-w-56 text-base': !compact()}" [value]="interalSearchValue()" [class]="`w-${width()}`" [placeholder]="placeholder()" (keyup.enter)="handleEnter($event)" (keyup)="handleChange($event)" />
    @if (interalSearchValue() !== '') {
        <div class="h-full absolute inset-y-0 right-2 flex items-center pl-2 cursor-pointer" (click)="onClear()">
            <img [src]="images.close" alt="clear" class="w-5 h-5" />
        </div>
    }
</div>
